import { render, staticRenderFns } from "./InstituteAddForm.vue?vue&type=template&id=2f3e6432&"
import script from "./InstituteAddForm.vue?vue&type=script&lang=js&"
export * from "./InstituteAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports